import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
    SignData: [],
    signCount: 0,
    isFetching: false,
    isSignSuccess: false,
    isSignAdded: false,
    isError: false,
    errorMessage: '',
    imagePath: '',
};

export const getSignatureList = createAsyncThunk(
    '/api/getsignature',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
            let response = await axios({
                url: `/api/${userType}/signature`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);

export const addSignature = createAsyncThunk(
    'api/addsignature',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
            const response = await axios.post(`/api/${userType}/signature`, udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;

            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);


export const delSignature = createAsyncThunk(
    '/api/delsignature',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
            let response = await axios({
                url: `/api/${userType}/signature/${udata}`,
                method: 'delete',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);



export const SignatureListSlice = createSlice({
    name: 'viewsignaturelist',
    initialState,
    reducers: {
        clearStateSignatureList: (state, { payload }) => {
            state.SignData = [];
            state.signCount = 0;
            state.isFetching = false;
            state.isSignSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
        },
        clearStateAddSignature: (state, { payload }) => {
            state.isSignAdded = false;
            state.isFetching = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },

    extraReducers: {
        [getSignatureList.fulfilled]: (state, { payload }) => {
            state.SignData = payload.data.data;
            state.signCount = payload.data.count;
            state.imagePath = payload.data.path;
            state.isFetching = false;
            state.isSignSuccess = true;
            return state;
        },
        [getSignatureList.pending]: (state) => {
            state.isFetching = true;
        },
        [getSignatureList.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },



        [addSignature.fulfilled]: (state, { payload }) => {
            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success) state.isSignAdded = true;
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';
            return state;
        },
        [addSignature.pending]: (state) => {
            state.isFetching = true;
        },
        [addSignature.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }

    },
});



export const { clearStateSignatureList, clearStateAddSignature } = SignatureListSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateSignatureList());
    }
}

export function clearStateAddSign() {

    return async (dispatch) => {
        dispatch(clearStateAddSignature());
    }
}

export const ViewSignatureListSelector = (state) => state.viewsignaturelist;

export default SignatureListSlice.reducer;
